import { useMemo } from 'react';

import { useApp } from 'utils/hooks/useApp';

const useFilteredItems = (items, settingKey, keyProperty = 'dataKey') => {
  const { customizeFieldData } = useApp();

  return useMemo(() => {
    if (!settingKey || !customizeFieldData?.[settingKey]) {
      return items;
    }

    const excludedKeys = new Set(customizeFieldData[settingKey]);
    return items.filter(item => !excludedKeys.has(item[keyProperty]));
  }, [items, settingKey, keyProperty, customizeFieldData]);
};

export default useFilteredItems;
